import { FormControl, styled } from "@mui/material";

const LoginInputFormStyled = styled(FormControl)({
    "& label.Mui-focused": {
        color: "#586A84",
        fontSize: 16,
        top: "3px",
    },
    "& label": {
        color: "#586A84",
        fontSize: 16,
        top: "1px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "6px",
    },
    "& label.MuiFormLabel-filled.MuiInputLabel-shrink": {
        color: "#586A84",
        fontSize: 16,
        top: "3px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#586A84",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#586A84",
    },
    "& .MuiOutlinedInput-root": {
        "&:hover fieldset": {
            borderColor: "#405289",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#405289",
        },
    },
    "& .MuiFormLabel-root": {
        lineHeight: "14px",
        fontSize: "14px",
        top: "-2px",
    },
});

export default LoginInputFormStyled;
